import React from "react";
import { X } from "lucide-react";

/**
 * Fullscreen overlay rendered on the student smart board when the
 * teacher has captured a student's answer photo and pushed it via the
 * Camera FAB. State key: `studentAnswerPhoto` — a base64 data-URL.
 *
 * Visible on top of everything else (z-50) but below toasts. Has a
 * dismiss button so a co-teacher on the laptop can close it without
 * needing the mobile.
 */
const StudentAnswerPhotoOverlay = ({ photo, onClose }) => {
    if (!photo) return null;
    return (
        <div
            data-testid="student-answer-photo-overlay"
            className="fixed inset-0 z-40 bg-white flex flex-col items-start justify-start animate-in fade-in duration-300"
        >
            {onClose && (
                <button
                    data-testid="student-answer-photo-close-btn"
                    onClick={onClose}
                    className="absolute top-5 right-5 w-11 h-11 rounded-full bg-black/10 hover:bg-black/20 flex items-center justify-center transition-all z-50"
                    title="Close"
                >
                    <X className="w-5 h-5 text-[#14202a]" />
                </button>
            )}

            <img
                src={photo}
                alt="Student's worked-out answer"
                style={{
                    position: "absolute",
                    top: "30px",
                    bottom: "30px",
                    left: "30px",
                    height: "calc(100% - 60px)",
                    objectFit: "contain",
                    borderRadius: "12px",
                    boxShadow: "0 10px 30px rgba(0,0,0,0.15)",
                }}
            />
        </div>
    );
};

export default StudentAnswerPhotoOverlay;
